(function () {
  const animationTimers = new WeakMap();

  const stopAnimation = (element) => {
    const timer = animationTimers.get(element);
    if (timer) window.clearTimeout(timer);
    animationTimers.delete(element);
    element.style.transition = "none";
    element.style.overflow = "hidden";
  };

  const finishAnimation = (element, hidden) => {
    element.style.display = hidden ? "none" : "block";
    element.style.removeProperty("height");
    element.style.removeProperty("overflow");
    element.style.removeProperty("transition");
    animationTimers.delete(element);
  };

  const slideUp = (element, duration) => {
    if (!element || window.getComputedStyle(element).display === "none") return;
    stopAnimation(element);
    element.style.height = `${element.getBoundingClientRect().height}px`;
    void element.offsetHeight;
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = "0px";
    animationTimers.set(
      element,
      window.setTimeout(() => finishAnimation(element, true), duration),
    );
  };

  const slideDown = (element, duration) => {
    if (!element) return;
    stopAnimation(element);
    element.style.display = "block";
    element.style.height = "0px";
    void element.offsetHeight;
    const targetHeight = element.scrollHeight;
    element.style.transition = `height ${duration}ms ease`;
    element.style.height = `${targetHeight}px`;
    animationTimers.set(
      element,
      window.setTimeout(() => finishAnimation(element, false), duration),
    );
  };

  const elementHeight = (selector) =>
    document.querySelector(selector)?.getBoundingClientRect().height || 0;

  const descriptionFor = (title) =>
    title.parentElement?.querySelector(":scope > .product-collapsible-row__description") || null;

  const initProductAccordion = () => {
    document.querySelectorAll(".product-collapsible-row__title").forEach((title) => {
      if (title.dataset.iigCollapsibleBound === "true") return;
      title.dataset.iigCollapsibleBound = "true";

      title.addEventListener("click", function () {
        const description = descriptionFor(title);

        if (!title.classList.contains("active")) {
          document
            .querySelectorAll(".product-collapsible-row__title.active")
            .forEach((activeTitle) => activeTitle.classList.remove("active"));
          title.classList.add("active");

          document
            .querySelectorAll(".product-collapsible-row__description")
            .forEach((item) => {
              if (item !== description) slideUp(item, 300);
            });
          slideDown(description, 300);

          const autoNavigation = title.dataset.autoNavigation === "true";
          if (autoNavigation && window.innerWidth < 990) {
            window.setTimeout(() => {
              const position =
                title.getBoundingClientRect().top +
                window.scrollY -
                elementHeight(".header-wrapper") -
                elementHeight(".section-announcement") -
                elementHeight(".countdown-timer-bar");

              window.scrollTo({ top: position, behavior: "smooth" });
            }, 400);
          }
        } else {
          title.classList.remove("active");
          slideUp(description, 300);
        }
      });
    });
  };

  document.addEventListener("shopify:section:load", initProductAccordion);
  initProductAccordion();
})();
